import React from 'react'
function Loader() {
    return (
        <div className='loader-spin'>
            <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
    )
}

export default Loader